import { createTheme } from '@material-ui/core/styles'
import { getProfileTheme } from 'services/colors'

// ╔╦╗╔═╗╔╦╗╔═╗╔╦╗╔═╗╔╦╗╔═╗
// ║║║║╣  ║ ╠═╣ ║║╠═╣ ║ ╠═╣
// ╩ ╩╚═╝ ╩ ╩ ╩═╩╝╩ ╩ ╩ ╩ ╩

function pxToRem(value) {
  return `${value / 16}rem`
}

export const colors = {
  notification: '#FF6767',
  background: '#F7F7F7',
  backgroundTable: '#F6F6F6',
  white: '#FFF',
  success: '#58C440',
  error: '#F87D67',
  ...getProfileTheme(),
}

export const THEME_DEFAULTS = {
  palette: {
    primary: {
      main: colors.color500,
    },
    secondary: {
      main: colors.main,
    },
    error: {
      main: colors.error,
    },
    success: {
      main: colors.success,
    },
  },
  typography: {
    fontFamily: ['Roboto Slab', 'sans-serif'].join(','),
    body1: {
      fontSize: 14,
    },
    body2: {
      fontSize: 12,
    },
    button: {
      fontWeight: 700,
      lineHeight: 24 / 14,
      fontSize: pxToRem(14),
      textTransform: 'unset',
    },
  },
}

export const theme = createTheme({ ...THEME_DEFAULTS })

export default theme
